import { render, staticRenderFns } from "./btn_page.vue?vue&type=template&id=18133df4&scoped=true&"
import script from "./btn_page.vue?vue&type=script&lang=js&"
export * from "./btn_page.vue?vue&type=script&lang=js&"
import style0 from "./btn_page.vue?vue&type=style&index=0&id=18133df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18133df4",
  null
  
)

export default component.exports